import { render, staticRenderFns } from "./dataNone.vue?vue&type=template&id=f7a9d5f4&scoped=true"
import script from "./dataNone.vue?vue&type=script&lang=js"
export * from "./dataNone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a9d5f4",
  null
  
)

export default component.exports